/**
 * True when a page thumbnail URL is a real inline preview.
 *
 * Signed storage URLs often append extra query params after
 * `response-content-disposition=inline` (for example transfer acceleration).
 * Do not match the URL tail — parse the query instead.
 *
 * @param {unknown} url
 * @returns {boolean}
 */
export default function isInlinePagePreviewUrl(url) {
  if (typeof url !== 'string' || !url) {
    return false;
  }

  try {
    const disposition = new URL(url, 'https://pics.io')
      .searchParams
      .get('response-content-disposition');
    return disposition === 'inline';
  } catch {
    return false;
  }
}
